import React from "react";
import { Row, Col } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
const CVProfileBio = ({ cvdata }) => {
  const now1 = 80;
  const now2 = 65;
  const now3 = 100;
  const now4 = 70;
  console.log("__________", cvdata);
  return (
    <Row>
      <Col md={8} lg={7} xl={6}>
        <div>
          <h5 className="text-color-cv1 fs-2 fw-bold mb-0">
            {cvdata?.profileInformation?.firstName}
          </h5>
          <h6 className="text-designation-color fs-5">
            {cvdata?.profileInformation?.jobDesignation}
          </h6>
          <hr className="lineColor py-1" />
        </div>
        <div className="profile-bio-scroll-1 noscroll">
          <div>
            <h6 className="text-color-cv1">Previous Employement Details</h6>
            {cvdata?.preemphistory?.map((item, index) => (
              <React.Fragment key={index}>
                <Row>
                  <Col md={6} lg={6}>
                    <div>
                      <p className="updateSize mb-0 mb-0">Company Name</p>
                      <p className="text-designation-color">
                        {item?.companyname}
                      </p>
                    </div>
                    <div>
                      <p className="updateSize mb-0">Start Date</p>
                      <p className="text-designation-color">
                        {item?.startdate}
                      </p>
                    </div>
                    <div>
                      <p className="updateSize mb-0">Industry</p>
                      <p className="text-designation-color">{item?.industry}</p>
                    </div>
                  </Col>

                  <Col md={6} lg={6}>
                    <div>
                      <p className="updateSize mb-0">Designation</p>
                      <p className="text-designation-color">
                        {item?.designation}
                      </p>
                    </div>
                    <div>
                      <p className="updateSize mb-0">End Date</p>
                      <p className="text-designation-color">{item?.enddate}</p>
                    </div>
                  </Col>
                </Row>
                <hr></hr>
              </React.Fragment>
            ))}

            <hr
              className="lineColor  mt-0 mb-3"
              style={{ padding: "2px 0px" }}
            />
          </div>
          <div>
            <h6 className="text-color-cv1">Formal Education</h6>
            {cvdata?.formaleducation?.map((item, index) => (
              <React.Fragment key={index}>
                <Row>
                  <Col md={6} lg={6}>
                    <div>
                      <p className="updateSize mb-0">Institute Name</p>
                      <p className="text-designation-color">
                        {item?.institutename}
                      </p>
                    </div>
                    <div>
                      <p className="updateSize mb-0">Qualification</p>
                      <p className="text-designation-color">
                        {item?.qualification}
                      </p>
                    </div>
                    <div>
                      <p className="updateSize mb-0">Start Date</p>
                      <p className="text-designation-color">
                        {item?.startdate}
                      </p>
                    </div>
                    <div>
                      <p className="updateSize mb-0">Degree Status</p>
                      <p className="text-designation-color">
                        {item?.degreestatus}
                      </p>
                    </div>
                  </Col>
                  <Col md={6} lg={6}>
                    <div>
                      <p className="updateSize mb-0">Major</p>
                      <p className="text-designation-color">{item?.major}</p>
                    </div>
                    <div>
                      <p className="updateSize mb-0">Type of Study</p>
                      <p className="text-designation-color">
                        {item?.typeofstudy}
                      </p>
                    </div>
                    <div>
                      <p className="updateSize mb-0">End Date</p>
                      <p className="text-designation-color">{item?.enddate}</p>
                    </div>
                  </Col>
                </Row>
                <hr></hr>
              </React.Fragment>
            ))}

            <hr
              className="lineColor  mt-0 mb-3"
              style={{ padding: "2px 0px" }}
            />
          </div>
          <div>
            <h6 className="text-color-cv1">Professional Skills</h6>
            <Row>
              <Col md={6} lg={6}>
                {cvdata?.profesionalskils?.length > 0 && (
                  <ul
                    style={{
                      listStyleType: "disc",
                      paddingLeft: "20px",
                      fontSize: "14px",
                      lineHeight: "1.6",
                    }}
                  >
                    {cvdata.profesionalskils.map((skill, index) => (
                      <li key={index}>{skill}</li>
                    ))}
                  </ul>
                )}
              </Col>
            </Row>
          </div>

          <div>
            <h6 className="text-color-cv1">Language Skills</h6>

            {cvdata?.languageskils?.length > 0 ? (
              cvdata.languageskils.map((item, index) => (
                <div className="mb-2" key={index}>
                  <Row className="mb-2">
                    <Col md={6} lg={6}>
                      <div>
                        <p className="updateSize mb-0">Language</p>
                        <p className="text-designation-color">
                          {item.language}
                        </p>
                      </div>
                      <div>
                        <p className="updateSize mb-0">Reading proficiency</p>
                        <p className="text-designation-color">
                          {item.readingproficiency}
                        </p>
                      </div>
                    </Col>
                    <Col md={6} lg={6}>
                      <div>
                        <p className="updateSize mb-0">Speaking Proficiency</p>
                        <p className="text-designation-color">
                          {item.speakingproficiency || item.speekingproficiency}
                        </p>
                      </div>
                      <div>
                        <p className="updateSize mb-0">Writing Proficiency</p>
                        <p className="text-designation-color">
                          {item.writingproficiency}
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <hr></hr>
                </div>
              ))
            ) : (
              <p>No language skills added.</p>
            )}

            <hr
              className="lineColor mt-0 mb-3"
              style={{ padding: "2px 0px" }}
            />
          </div>

          <div>
            <h6 className="text-color-cv1">Certifications/Licences</h6>
            {cvdata?.certification?.map((item, index) => (
              <React.Fragment key={index}>
                <Row>
                  <Col md={6} lg={6}>
                    <div>
                      <p className="updateSize mb-0">Name of Certifications</p>
                      <p className="text-designation-color">
                        {item?.nameofcertificate}
                      </p>
                    </div>
                    <div>
                      <p className="updateSize mb-0">Issuing Authority</p>
                      <p className="text-designation-color">
                        {item?.issuingauthority}
                      </p>
                    </div>
                    <div>
                      <p className="updateSize mb-0">Expiring Date</p>
                      <p className="text-designation-color">
                        {item?.expirationdate}
                      </p>
                    </div>
                  </Col>
                  <Col md={6} lg={6}>
                    <div>
                      <p className="updateSize mb-0">Institution</p>
                      <p className="text-designation-color">
                        {item?.institution}
                      </p>
                    </div>
                    <div>
                      <p className="updateSize mb-0">Effective Date</p>
                      <p className="text-designation-color">
                        {item?.effectivedate}
                      </p>
                    </div>
                  </Col>
                </Row>
                <hr></hr>
              </React.Fragment>
            ))}
          </div>
        </div>
      </Col>
    </Row>
  );
};
export default CVProfileBio;
